import axios from "axios";

export const getBotSettings = async (botId) => {
  const settings = await axios.get(`/api/client-configuration/${botId}`);

  return settings.data;
};
